import { getApproveRequestApi } from 'Api/approveRequest';
import { Divider, Modal, Table } from 'antd';
import { Loader } from 'components/Global';
import Buttons from 'components/Global/Buttons';
import { useEffect, useState } from 'react';
import { invalidText, toastText } from 'utils/utils';
import styles from './index.module.scss';
import DownloadComponent from 'components/Global/Download';
import EmployeeShareComponent from 'components/Settings/PayrollSettings/StatutoryComponent/PayeTab/ToolTip';
import dayjs from 'dayjs';
import './index.scss';
type Props = {
	isDeleteNotificationModalOpen: boolean;
	handleCancel: () => void;
	approvalId: string | null;
	notificationId: string | null;
};

const AddPushNotificationModal = (props: Props) => {
	const [notificationData, setNotificationData] = useState<any[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const [displayData, setDisplayData] = useState<any[]>([]);
	const [approveIsLoading, setApproveIsLoading] = useState(false);
	const [rejectIsLoading, setRejectIsLoading] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const attachmentTitle = ['Attachment', 'Combine Pay Slip'];
	const timeTitles = ['Start Time', 'End Time'];
	const {
		isDeleteNotificationModalOpen,
		handleCancel,
		approvalId,
		notificationId,
	} = props;

	const buttons = [
		{
			text: 'Reject',
			isSubmit: true,
			className: 'secondary-button',
			// onclick: rejectNotification,
			minWidth: '10rem',
			minHeight: '42px',
			onclick: () => {
				rejectApprovalRequest();
			},
			disabled: isLoading || approveIsLoading || rejectIsLoading,
			isLoading: rejectIsLoading,
		},
		{
			text: 'Approve',
			isSubmit: true,
			className: 'btn-blue',
			onclick: () => {
				acceptApprovalRequest();
			},
			disabled: isLoading || approveIsLoading || rejectIsLoading,
			minWidth: '60px',
			minHeight: '42px',
			isLoading: approveIsLoading,
		},
	];

	const acceptApprovalRequest = async () => {
		try {
			setApproveIsLoading(true);
			await getApproveRequestApi.acceptDeleteNotificationApproval({
				approvalId: approvalId,
				userNotificationId: notificationId,
			});
			toastText(
				`${modalTitle || 'Approval'} deleted Successfully!`,
				'success'
			);

			handleCancel();
		} catch (error: any) {
			const message =
				error?.response?.data?.message ||
				'Something went wrong in accepting delete approval';
			toastText(message, 'error');
		} finally {
			setApproveIsLoading(false);
		}
	};

	const rejectApprovalRequest = async () => {
		try {
			setRejectIsLoading(true);
			await getApproveRequestApi.rejectDeleteNotificationApproval({
				approvalId: approvalId,
				userNotificationId: notificationId,
			});
			toastText(
				`${modalTitle || 'Approval'} Rejected Successfully!`,
				'success'
			);

			handleCancel();
		} catch (error: any) {
			const message =
				error?.response?.data?.message ||
				'Something went wrong in rejecting delete approval';
			toastText(message, 'error');
		} finally {
			setRejectIsLoading(false);
		}
	};

	const fetchApprovalRequest = async () => {
		try {
			setIsLoading(true);
			const response =
				await getApproveRequestApi.getApprovalRequestsForNotification({
					approvalId: approvalId,
				});
			const _data = response.data.data;

			setNotificationData(_data.data);
			setDisplayData(_data.displayData);
			setModalTitle(_data.modalTitle);
		} catch (error) {
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (isDeleteNotificationModalOpen) {
			fetchApprovalRequest();
		}
	}, [isDeleteNotificationModalOpen]);

	const renderNotificationData = () => {
		if (isLoading) {
			return (
				<div className={styles['loader-container']}>
					<Loader />
				</div>
			);
		}

		if (!notificationData?.length) {
			return (
				<div
					className={styles['delete-notification-modal--icon__text']}
				>
					No approval request present!
				</div>
			);
		}

		const titles = Object.keys(displayData);

		const content = Object.values(displayData);

		return (
			<div className={styles['delete-notification-modal__list']}>
				{titles.map((title, index) => {
					const contentAtIndex = attachmentTitle.includes(title)
						? JSON.parse(content[index])
						: content[index];
					// Custom rendering for Shift Assignment
					if (title === 'Employee Details') {
						const employees = JSON.parse(content[index] || '[]');

						return (
							<div key={index}>
								<div
									className="employee-shift-table"
									style={{
										overflow: 'auto',
										border: '1px solid #f0f0f0',
										borderRadius: '4px',
										padding: '8px',
									}}
								>
									<Table
										dataSource={employees}
										scroll={{ y: 250 }}
										columns={[
											{
												title: 'Employee Details',
												key: 'employee',
												render: (_, record) => {
													const code =
														record.employee
															?.employeeId || '-';
													const fullName = `${
														record.employee
															?.firstName || ''
													} ${
														record.employee
															?.midName || ''
													} ${
														record.employee
															?.lastName || ''
													}`;
													return (
														<div
															style={{
																maxWidth:
																	'maxContent',
																whiteSpace:
																	'nowrap',
																overflow:
																	'hidden',
																textOverflow:
																	'ellipsis',
															}}
															title={`${code} | ${fullName}`}
														>
															<span
																style={{
																	color: '#584495',
																	fontWeight: 600,
																}}
															>
																{code}
															</span>{' '}
															| {fullName}
														</div>
													);
												},
											},
										]}
										pagination={false}
										rowKey={(record) =>
											record.employee?.employeeId ||
											record.id
										}
										size="small"
									/>
								</div>
							</div>
						);
					}

					return (
						<div
							key={index}
							className={
								styles['delete-notification-modal__list--item']
							}
						>
							<div
								style={{
									width: '30%',
									fontWeight: 'bold',
									fontSize: '14px',
								}}
							>
								{title}
							</div>
							{title === 'Paye Employee Share' ? (
								EmployeeShareComponent({
									employeeShare: content[index],
									placement: 'right',
								})
							) : attachmentTitle.includes(title) ? (
								<div>
									<DownloadComponent
										documentUrl={contentAtIndex?.fileUrl}
										downloadText={contentAtIndex?.fileName}
										showTooltip={true}
										text={contentAtIndex?.fileName}
										isLink={true}
										maxLength={40}
									/>
								</div>
							) : (
								<div>
									{timeTitles.includes(title)
										? dayjs(contentAtIndex).format(
												'HH:mm a'
										  )
										: invalidText(contentAtIndex)
										? '-'
										: contentAtIndex}
								</div>
							)}
						</div>
					);
				})}
			</div>
		);
	};

	return (
		<Modal
			open={isDeleteNotificationModalOpen}
			onCancel={handleCancel}
			okText="Save"
			closable={false}
			width={600}
			footer={() => (
				<div className={styles.footerButtons}>
					<Buttons buttons={buttons} />
				</div>
			)}
		>
			{!isLoading && (
				<div className={styles['delete-notification-modal']}>
					<p className={styles['delete-notification-modal__title']}>
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								flexDirection: 'column',
								marginBottom: '10px',
							}}
						>
							{/* <ExclamationCircleOutlined
									style={{
										fontSize: '40px',
										color: 'red',
										marginBottom: '10px',
									}}
								/> */}
						</div>
						<h3
							className={
								styles['delete-notification-modal__title']
							}
						>
							Are you sure want to Delete{' '}
							<span
								style={{
									color: '#FF0000',
								}}
							>
								{modalTitle}
							</span>
							?
						</h3>
					</p>
					{!isLoading && (
						<Divider
							style={{
								margin: '1rem 0 1rem 0',
							}}
						/>
					)}
				</div>
			)}
			{renderNotificationData()}
		</Modal>
	);
};

export default AddPushNotificationModal;
